import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

const PrivacyPolicy = () => {
  const { t } = useLanguage();
  const copy = t("privacyPolicy");

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-emerald-50">
      <section id="privacy-policy-hero" className="py-20 bg-gradient-to-br from-emerald-500 via-teal-600 to-green-600 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-400/20 to-teal-400/20"></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 animate-slide-in-up drop-shadow-lg">
              {t("interface.privacyTitle")}
            </h1>
            <p className="text-lg text-emerald-100 animate-fade-in font-medium">
              {copy.hero.updated}
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gradient-to-b from-white to-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <div className="animate-fade-in bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-emerald-100 p-8 md:p-12">
              <div className="bg-gradient-to-r from-emerald-50 to-teal-50 border-l-4 border-emerald-500 p-6 rounded-r-lg mb-8">
                {copy.intro.map((paragraph) => (
                  <p key={paragraph} className="text-slate-700 leading-relaxed mb-4 last:mb-0 font-medium">
                    {paragraph}
                  </p>
                ))}
              </div>

              {copy.sections.map((section, index) => (
                <section key={section.title} aria-labelledby={`privacy-section-${index}`}>
                  <h2 id={`privacy-section-${index}`} className="text-2xl font-bold text-slate-800 mb-4 mt-8 flex items-center">
                    <span className="w-2 h-8 bg-gradient-to-b from-emerald-500 to-teal-600 rounded-full mr-3"></span>
                    {section.title}
                  </h2>

                  {section.paragraphs?.map((paragraph) => (
                    <p key={paragraph} className="text-slate-700 leading-relaxed mb-6">
                      {paragraph}
                    </p>
                  ))}

                  {section.items && (
                    <div className={index === 0 ? "bg-slate-50 rounded-lg p-6 mb-6 border border-slate-200" : "mb-6"}>
                      <ul className={index === 0 ? "space-y-3" : "list-disc pl-6 space-y-2"}>
                        {section.items.map((item) => (
                          <li key={`${item.label || "item"}-${item.text}`} className="text-slate-700">
                            {item.label ? <strong className="text-slate-800">{item.label}</strong> : null}{item.label ? " " : ""}{item.text}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {index === 3 && (
                    <p className="text-slate-700 leading-relaxed mb-6">
                      <a href="https://www.intelevia.com/pages/data-sharing-opt-out" className="text-emerald-600 hover:text-emerald-700 font-medium underline">{copy.links.optOut}</a>
                    </p>
                  )}

                  {index === 4 && (
                    <p className="text-slate-700 leading-relaxed mb-6">
                      <a href="https://www.shopify.com/legal/privacy/app-users" className="text-emerald-600 hover:text-emerald-700 font-medium underline mr-4">{copy.links.shopifyPolicy}</a>
                      <a href="https://privacy.shopify.com/en" className="text-emerald-600 hover:text-emerald-700 font-medium underline">{copy.links.shopifyPortal}</a>
                    </p>
                  )}

                  {index === 8 && (
                    <p className="text-slate-700 leading-relaxed mb-6">
                      <a href="https://www.intelevia.com/pages/data-sharing-opt-out" className="text-emerald-600 hover:text-emerald-700 font-medium underline mr-4">{copy.links.optOut}</a>
                      <a href="https://globalprivacycontrol.org/" className="text-emerald-600 hover:text-emerald-700 font-medium underline">{copy.links.globalPrivacy}</a>
                    </p>
                  )}
                </section>
              ))}

              <h2 id="privacy-section-contact" className="text-2xl font-bold text-slate-800 mb-4 mt-8 flex items-center">
                <span className="w-2 h-8 bg-gradient-to-b from-emerald-500 to-teal-600 rounded-full mr-3"></span>
                {copy.contact.title}
              </h2>
              <p className="text-slate-700 leading-relaxed mb-6">
                {copy.contact.before}{" "}
                <a href="mailto:kylendar1@gmail.com" className="text-emerald-600 hover:text-emerald-700 font-medium underline">kylendar1@gmail.com</a>{" "}
                {copy.contact.after}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
